import { escapeHtml, isSafeUrl, sanitizeUrl } from "./index";

/**
 * Safely converts a lightweight subset of Markdown (*italic*, **bold**, `code`, [link](url))
 * into secure HTML. Guarantees zero XSS by HTML-escaping all input before tag injection.
 */
export function renderMicroMarkdown(input: unknown): string {
  if (input === null || input === undefined) return "";
  
  let text = escapeHtml(String(input));
  
  // 1. Inline Code: `code`
  text = text.replace(/`([^`\n]+?)`/g, '<code class="px-1.5 py-0.5 rounded text-xs font-mono bg-muted/50">$1</code>');
  
  // 2. Bold: **text** or __text__
  text = text.replace(/\*\*([^\n*]+?)\*\*/g, '<strong>$1</strong>');
  text = text.replace(/__([^\n_]+?)__/g, '<strong>$1</strong>');
  
  // 3. Italic: *text* or _text_
  text = text.replace(/\*([^\n*]+?)\*/g, '<em>$1</em>');
  text = text.replace(/_([^\n_]+?)_/g, '<em>$1</em>');
  
  // 4. Safe Links: [Label](url)
  text = text.replace(/\[([^\n\]]+?)\]\((https?:\/\/[^\s\)]+|mailto:[^\s\)]+|tel:[^\s\)]+)\)/g, (match, label, url) => {
    // Decode HTML entities in the URL to validate the actual protocol
    const cleanUrl = url.replace(/&amp;/g, "&");
    
    if (!isSafeUrl(cleanUrl)) {
      return match; // Return the raw escaped text if the URL is unsafe
    }
    
    return `<a href="${sanitizeUrl(cleanUrl)}" target="_blank" rel="noopener noreferrer" class="underline underline-offset-2 hover:opacity-80 transition-opacity">${label}</a>`;
  });
  
  return text;
}
